// @flow

import type { GenericEventConfig } from '@chatchamp/chatchamp-types'

import { logger } from '../../../../common'
import type { EventPayload } from '../../../../common/iframeMessageTypes'

import { type EventSenderType, EVENT_SENDERS } from '../../types'
import { replacePlaceholdersFromJSON } from '../../utils'

// only exported for unit test
export function isTealiumAvailable (): boolean {
  return (typeof window.utag?.link === 'function')
}

// only exported for unit test
export function fireTealiumEvent (payload: Object): void {
  window.utag.link(payload)
}

// only exported for unit test
export function getTealiumEventConfig (eventName: string, eventSender: EventSenderType = EVENT_SENDERS.CHATBOT): GenericEventConfig {
  if (eventSender === EVENT_SENDERS.WIZARD) {
    return window.chatchamp.config.tracking?.tealiumConfig.wizardEvents.find((e) => e.eventName === eventName)
  } else {
    return window.chatchamp.config.tracking?.tealiumConfig.events.find((e) => e.eventName === eventName)
  }
}

export function forwardEventToTealium (eventPayload: EventPayload): void {
  if (!isTealiumAvailable()) return

  const tealiumEventConfig: GenericEventConfig = getTealiumEventConfig(eventPayload.event)

  if (tealiumEventConfig) {
    const payload = replacePlaceholdersFromJSON(tealiumEventConfig.payload, eventPayload)

    logger.info(`Firing event ${eventPayload.event} with payload ${JSON.stringify(payload)} to Tealium...`)
    try {
      fireTealiumEvent(payload)
    } catch (err) {
      logger.error(err)
    }
  }
}
